// import { useRef, useState, useCallback } from "react";

// export const useStreamingAI = () => {
//   const [text, setText] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [typing, setTyping] = useState(false);
//   const [speaking, setSpeaking] = useState(false);

//   const bufferRef = useRef("");
//   const sentenceQueueRef = useRef([]);
//   const isInterruptedRef = useRef(false);

//   const speakNext = useCallback(() => {
//     if (speaking || sentenceQueueRef.current.length === 0) return;

//     const sentence = sentenceQueueRef.current.shift();
//     if (!sentence) return;

//     const utterance = new SpeechSynthesisUtterance(sentence);
//     setSpeaking(true);

//     utterance.onend = () => {
//       setSpeaking(false);
//       speakNext();
//     };

//     utterance.onerror = () => {
//       setSpeaking(false);
//       speakNext();
//     };

//     window.speechSynthesis.speak(utterance);
//   }, [speaking]);

//   const extractSentences = (chunk) => {
//     bufferRef.current += chunk;

//     const matches = bufferRef.current.match(/[^.!?]+[.!?]/g);
//     if (!matches) return;

//     matches.forEach(sentence => {
//       sentenceQueueRef.current.push(sentence.trim());
//     });

//     bufferRef.current = bufferRef.current.replace(
//       matches.join(""),
//       ""
//     );

//     speakNext();
//   };

//   const sendMessage = async (url, payload) => {
//     setLoading(true);
//     setTyping(true);
//     setText("");
//     bufferRef.current = "";
//     sentenceQueueRef.current = [];
//     isInterruptedRef.current = false;

//     try {
//       const response = await fetch(url, {
//         method: "POST",
//         body: JSON.stringify(payload),
//       });

//       if (!response.body) throw new Error("No stream");

//       const reader = response.body.getReader();
//       const decoder = new TextDecoder();

//       while (true) {
//         const { value, done } = await reader.read();
//         if (done || isInterruptedRef.current) break;

//         const chunk = decoder.decode(value, { stream: true });

//         setText(prev => prev + chunk);
//         extractSentences(chunk);
//       }
//     } catch (err) {
//       console.error("Streaming error", err);
//     } finally {
//       setLoading(false);
//       setTyping(false);
//     }
//   };

//   const interrupt = () => {
//     isInterruptedRef.current = true;
//     window.speechSynthesis.cancel();
//     sentenceQueueRef.current = [];
//     setSpeaking(false);
//   };

//   const pause = () => {
//     window.speechSynthesis.pause();
//     setSpeaking(false);
//   };

//   const resume = () => {
//     window.speechSynthesis.resume();
//     setSpeaking(true);
//   };

//   return {
//     sendMessage,
//     interrupt,
//     pause,
//     resume,
//     text,
//     loading,
//     typing,
//     speaking,
//   };
// };




import { useRef, useState, useCallback } from "react";

export const useStreamingAI = () => {
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(false);
  const [typing, setTyping] = useState(false);
  const [speaking, setSpeaking] = useState(false);

  const sentenceQueueRef = useRef([]);
  const isInterruptedRef = useRef(false);

  const speakNext = useCallback(() => {
    if (speaking || sentenceQueueRef.current.length === 0) return;

    const sentence = sentenceQueueRef.current.shift();
    if (!sentence) return;

    const utterance = new SpeechSynthesisUtterance(sentence);
    setSpeaking(true);

    utterance.onend = () => {
      setSpeaking(false);
      speakNext();
    };

    utterance.onerror = () => {
      setSpeaking(false);
      speakNext();
    };

    window.speechSynthesis.speak(utterance);
  }, [speaking]);

  const extractSentences = (fullText) => {
    const matches = fullText.match(/[^.!?]+[.!?]/g);
    if (!matches) return;

    sentenceQueueRef.current = matches.map(s => s.trim());
    speakNext();
  };

  const sendMessage = async (url, payload) => {
    setLoading(true);
    setTyping(true);
    setText("");
    sentenceQueueRef.current = [];
    isInterruptedRef.current = false;

    try {
      const response = await fetch(url, {
        method: "POST",
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (isInterruptedRef.current) return;

      const finalText = data.response || data.text || data.message || "";

      setText(finalText);

      extractSentences(finalText);
    } catch (err) {
      console.error("AI response error", err);
    } finally {
      setLoading(false);
      setTyping(false);
    }
  };

  const interrupt = () => {
    isInterruptedRef.current = true;
    window.speechSynthesis.cancel();
    sentenceQueueRef.current = [];
    setSpeaking(false);
  };

  const pause = () => {
    window.speechSynthesis.pause();
    setSpeaking(false);
  };

  const resume = () => {
    window.speechSynthesis.resume();
    setSpeaking(true);
  };

  return {
    sendMessage,
    interrupt,
    pause,
    resume,
    text,
    loading,
    typing,
    speaking,
  };
};
